// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"826":"user-rights-roles","893":"login-home-welcome"}[chunkId] || chunkId) + "." + {"413":"9f6b8048","826":"33fe3fe9","893":"933e5763"}[chunkId] + ".css";
};